import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'truncateErrorMessagePipe',
  standalone: false,
})
export class TruncateErrorMessagePipe implements PipeTransform {
  transform(value: string, maxLength: number = 4000): string {
    if (!value) {
      return value // If there's no value, return it as is
    }

    // If the string exceeds maxLength, return '...' + last maxLength characters.
    return value.length > maxLength ? '...' + value.slice(-maxLength) : value
  }
}
